@let count = count$ | async;

<div class="gb-dialog-header">
  <h1 translate="TEAMS.CREATE_TEAM"></h1>
</div>

<div class="gb-dialog-content">
  <div class="content-container">
    <p translate="TEAMS.CREATE_DESCRIPTION"></p>

    <gb-form-field labelTranslateKey="TEAMS.TEAM_NAME" [control]="team"></gb-form-field>
  </div>
</div>

<div class="gb-dialog-actions-container gb-flex-button-container">
  <button mat-stroked-button mat-dialog-close>
    <span translate="CANCEL"></span>
  </button>
  <button mat-flat-button (click)="submit(count)" [loaded]="editCreateLoaded$ | async" [light]="false">
    <span translate="CREATE"></span>
  </button>
</div>
